import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import { NotificationsService } from 'angular2-notifications';
import { UserService } from "../user.service";
import { FilterParams } from "../../models/filter_form.model";

@Component({
	selector: 'live',
	templateUrl: './live.component.html'
})
export class LiveComponent extends BaseComponent {
	rows;
	
	listLoader = false;

	userRegSource = '';

	timerId = null;

	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		private notifications: NotificationsService,
		public userService: UserService,
	) {
		super(eventsService, userService, activatedRoute, filter, translate);
	}

	async getData() {
		await this.getList();
		
		this.setTimer();
	}

	async getList() {
		this.rows = [];

		if (this.timerId) {
			clearInterval(this.timerId);
		}

		this.listLoader = true;

		const { stats } = await this.userService.userLive.stats(
			<FilterParams>{
				userRegSource: this.userRegSource,
				lang: '',
				paidType: '',
			}
		).toPromise();
		this.rows = stats;
		this.rows.reverse();
		
		this.listLoader = false;

		this.showInfo(this.rows.length, 0);
	}
	
	
	setTimer() {
		const me = this;

		me.timerId = setTimeout(async function () {
			if (me.timerId) {
				clearInterval(me.timerId);
			}

			let addedCount = 0;
			let changedCount = 0;

			const { stats } = await me.userService.userLive.stats(
				<FilterParams>{
					userRegSource: me.userRegSource,
					lang: '',
					paidType: '',
				}
			).toPromise();
			stats.reverse();

			for (let rowNew of stats) {
				let user = me.rows.reduce(function (pre, cur) {
					return cur._id == rowNew._id ? cur : pre;
				}, null);

				if (user == null) {
					addedCount++;

					me.rows.unshift(rowNew);
				} else {
					if (rowNew.firstSiteDomain && rowNew.firstSiteDomain != user.firstSiteDomain) {
						changedCount++;

						user.firstSiteDomain = rowNew.firstSiteDomain;
						user.isUpdated = true;
					}
				}
			}

			if (addedCount > 0 || changedCount > 0) {
				me.showInfo(addedCount, changedCount);
			}

			me.setTimer();
		}, 30 * 1000);
	}
	
	showInfo(added: number, changed: number) {
		this.notifications.info('Пользователей', `Добавлено: ${added}; Обновлено: ${changed}`, {timeOut: 4000});
	}
	
	ngOnDestroy() {
		clearTimeout(this.timerId);
		
		super.ngOnDestroy();
	}
}
